var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "homebase-modal-header py-4 px-5" }, [
    _c(
      "div",
      { staticClass: "d-flex align-items-center justify-content-between" },
      [
        _c("div", [
          _vm.logoImgSrc
            ? _c("div", [_c("img", { attrs: { src: _vm.logoImgSrc } })])
            : _vm._e(),
          _vm._v(" "),
          _vm.title
            ? _c("div", { staticClass: "homebase-modal-title" }, [
                _vm._v(_vm._s(_vm.title))
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.subtitle
            ? _c("div", { staticClass: "homebase-modal-subtitle" }, [
                _vm._v("\n        " + _vm._s(_vm.subtitle) + "\n      ")
              ])
            : _vm._e()
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "close-icon",
            on: {
              click: function($event) {
                return _vm.onModalClose()
              }
            }
          },
          [
            _c("img", {
              attrs: {
                src: require("@/assets/image/homebase/modal_icon_close.svg")
              }
            })
          ]
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-31c8aea0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-31c8aea0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/homebase/modals/ModalHeader.vue
// module id = null
// module chunks = 